import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import { } from '@fortawesome/free-regular-svg-icons'

import {
  faUser, faLock, faSignOutAlt, faCog, faBolt, faChessKnight, faTachometerAlt, faChevronRight, faChevronLeft, faSearch, faBell, faEnvelope, faUsers, faFileInvoiceDollar, faGlobeAmericas, faEye, faTv, faFileDownload, faBars, faDollarSign, faCreditCard
} from '@fortawesome/free-solid-svg-icons'

import {
  faGithub
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faUser, faLock, faSignOutAlt, faCog, faGithub, faBolt, faChessKnight, faTachometerAlt, faChevronRight, faChevronLeft, faSearch, faBell, faEnvelope, faUsers, faFileInvoiceDollar, faGlobeAmericas, faEye, faTv, faFileDownload, faBars, faDollarSign, faCreditCard
)

Vue.component('fa', FontAwesomeIcon)
